"use strict";
/**
 * Recruitment-specific CRM reference data from the ORION CRM blueprint.
 * Separate from the LinkedIn-style `INDUSTRIES` list in ./industries.ts — these are the
 * agency's own taxonomy (main category + sub-vertical), used in CRM dropdowns.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_TYPE_OPTIONS = exports.CONTACT_STATUS_OPTIONS = exports.SENTIMENT_OPTIONS = exports.PRIORITY_OPTIONS = exports.SERVICE_TYPE_OPTIONS = exports.DEAL_STATUS_OPTIONS = exports.DEAL_STAGE_OPTIONS = exports.CRM_SKILLS = exports.CRM_MAIN_INDUSTRIES = exports.CRM_INDUSTRIES = exports.CRM_INDUSTRY_GROUPS = void 0;
/** Main industry → sub-verticals. */
exports.CRM_INDUSTRY_GROUPS = {
    Banking: ['Retail Banking', 'Corporate Banking', 'Investment Banking'],
    Insurance: ['Health Insurance', 'General Insurance'],
    Investment: ['Venture Capital', 'Private Equity', 'Public Market'],
    Finance: ['Lending'],
    FMCG: ['Food & Beverages', 'Traditional Pharmacology', 'Pharmacology'],
    Retails: ['Food and Beverages', 'Sports', 'Apparels'],
    Technology: [
        'Wealth Technology',
        'P2P Lending',
        'Health',
        'eCommerce',
        'Ride Hailing',
        'Logistic & Warehousing',
        'Data',
        'Software House',
        'F&B',
        'Biotech & Pharma',
        'Entertainment, Games & eSport'
    ],
    Transportation: ['Airlines, Taxis'],
    Manufacturing: [
        'EV',
        'F&B',
        'Sports and Apparels',
        'Combustion Engine Vehicle',
        'Green Energy Component'
    ],
    Mining: ['Coal', 'Mineral (Gold, Cooper, Nickel)']
};
/** Flat "Main - Sub" values for simple single-select dropdowns. */
exports.CRM_INDUSTRIES = Object.entries(exports.CRM_INDUSTRY_GROUPS).flatMap(([main, subs]) => subs.map((sub) => `${main} - ${sub}`));
/** Main industry categories only. */
exports.CRM_MAIN_INDUSTRIES = Object.keys(exports.CRM_INDUSTRY_GROUPS);
/** Skills taxonomy from the blueprint. */
exports.CRM_SKILLS = [
    'Investment Banking',
    'Financial Modeling',
    'Financial Valuation',
    'Accounting',
    'Commercial Finance',
    'Taxation',
    'Corporate Strategy',
    'Financial Operation',
    'Export/Import Duties',
    'Go To Market (GTM)',
    'Product F&B',
    'Product Software',
    'Product Hardware',
    'FMCG Sales',
    'Insurance Sales',
    'SAAS Sales',
    'Service Sales',
    'B2B Sales',
    'B2C Sales',
    'Software Engineer',
    'Hardware Engineer',
    'AI Engineer',
    'Python',
    'C++',
    'Java',
    'Javascript',
    'React',
    'Swift',
    'iOS Developer',
    'Android Developer',
    'HarmonyOS Developer'
];
/** Option lists for CRM enum fields (value/label pairs for selects). */
exports.DEAL_STAGE_OPTIONS = [
    { value: 'lead', label: 'Lead' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'interviewing', label: 'Interviewing' },
    { value: 'offer', label: 'Offer' },
    { value: 'placed', label: 'Placed' },
    { value: 'lost', label: 'Lost' }
];
exports.DEAL_STATUS_OPTIONS = [
    { value: 'open', label: 'Open' },
    { value: 'on_hold', label: 'On Hold' },
    { value: 'placed', label: 'Placed' },
    { value: 'failed', label: 'Failed' }
];
exports.SERVICE_TYPE_OPTIONS = [
    { value: 'recruitment_consultancy', label: 'Recruitment Consultancy' },
    { value: 'eor', label: 'EOR' }
];
exports.PRIORITY_OPTIONS = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
];
exports.SENTIMENT_OPTIONS = [
    { value: 'cold', label: 'Cold' },
    { value: 'warm', label: 'Warm' },
    { value: 'hot', label: 'Hot' }
];
exports.CONTACT_STATUS_OPTIONS = [
    { value: 'client', label: 'Client' },
    { value: 'candidate', label: 'Candidate / Talent' },
    { value: 'lead', label: 'Lead' },
    { value: 'partner', label: 'Partner' },
    { value: 'other', label: 'Other' }
];
exports.ACTIVITY_TYPE_OPTIONS = [
    { value: 'note', label: 'Note' },
    { value: 'call', label: 'Call' },
    { value: 'email', label: 'Email' },
    { value: 'meeting', label: 'Meeting' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'sms', label: 'SMS' },
    { value: 'task', label: 'Task' }
];
//# sourceMappingURL=crm.js.map